import React, { useEffect, useState } from "react";
import BASE_URL from "../apiConfig";
import useRecaptcha from "../hooks/useRecaptcha";
import "./Careers.css";
import technopark from "../images/technopark.jpg";
import group1 from "../images/group1.jpeg";
import group2 from "../images/group2.jpeg";
import group3 from "../images/group3.jpeg";
// import group4 from "../images/group4.jpeg";

function Careers() {
  const [jobs, setJobs] = useState([]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [expandedJob, setExpandedJob] = useState(null);
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    full_name: "",
    email: "",
    phone: "",
    resume: null,
    cover_letter: ""
  });
  const [widgetId, setWidgetId] = useState(null);
  const { getResponse } = useRecaptcha();

  useEffect(() => {
    if (selectedJob && window.grecaptcha) {
      setTimeout(() => {
        const container = document.getElementById("recaptcha-careers");
        if (container && container.innerHTML === "") {
          try {
            const id = window.grecaptcha.render(container, {
              // sitekey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
               sitekey: window.RECAPTCHA_SITE_KEY,
            });
            setWidgetId(id);
          } catch (err) {
            console.error("reCAPTCHA Careers render error:", err);
          }
        }
      }, 100);
    } else if (!selectedJob) {
      setWidgetId(null);
    }
  }, [selectedJob]);

  /* ===========================
     FETCH JOBS
  =========================== */
  useEffect(() => {
    setLoading(true);
    fetch(`${BASE_URL}/CarrerApi/careers`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch jobs");
        return res.json();
      })
      .then((data) => {
        setJobs(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  /* ===========================
     READ MORE TOGGLE
  =========================== */
  const toggleReadMore = (id) => {
    setExpandedJob(expandedJob === id ? null : id);
  };

  /* ===========================
     FORM CHANGE
  =========================== */
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "resume") {
      setFormData({ ...formData, resume: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  /* ===========================
     SUBMIT APPLICATION
  =========================== */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.resume) {
      alert("Please upload your resume.");
      return;
    }

    const token = getResponse(widgetId);
    if (!token) {
      alert("❌ Please complete the reCAPTCHA.");
      return;
    }
    const formDataObj = new FormData();
    formDataObj.append("career_id", selectedJob.id);
    formDataObj.append("full_name", formData.full_name);
    formDataObj.append("email", formData.email);
    formDataObj.append("phone", formData.phone);
    formDataObj.append("resume", formData.resume);
    formDataObj.append("cover_letter", formData.cover_letter);
    formDataObj.append("tk", token);

    try {
      const response = await fetch(`${BASE_URL}/CarrerApi/apply_job`, {
        method: "POST",
        body: formDataObj,
      });

      const responseText = await response.text();
      let result;
      try {
        result = JSON.parse(responseText);
      } catch (e) {
        console.error("Server returned non-JSON response:", responseText);
        throw new Error(`Server Error: ${response.status} ${response.statusText}`);
      }

      alert(result.message || "Application submitted successfully");
      if (result.message?.includes("successfully")) {
        setSelectedJob(null);
      }
    } catch (err) {
      console.error("Submission Error:", err);
      alert("❌ Submission Failed. Check Console.");
    }
  };

  return (
    <>
      {/* HERO */}
      <div
        className="bg-container-careers"
        style={{ backgroundImage: `url(${technopark})` }}
      ></div>

      <div className="careers-hero-wrapper">
        <div className="careers-hero-content">
          <h1>Careers at IGNOSI</h1>
          <h2>Join us in transforming the future of digital banking.</h2>
          <p>
            “Careers at IGNOSI belong to people who take ownership, deliver consistently and make the complex world of finance simple and reliable for our clients.”
          </p>
        </div>
      </div>

      {/* LIFE AT IGNOSI */}
      <section className="life-section">
        <h2>Life at IGNOSI</h2>
        <h4>We invest in people and build a team that feels they truly belong at IGNOSI. We value individuals who think differently and bring real-world ideas to the table.</h4>
        <div className="life-grid">
          <img src={group1} alt="Team Work" />
          <img src={group2} alt="Office Discussion" />
          <img src={group3} alt="Development" />
          {/* <img src={group4} alt="Meeting" /> */}
        </div>
      </section>

      {/* JOB LIST */}
      <section className="career-section">
        <h2>Current Openings</h2>

        {jobs.length === 0 && (
          <p style={{ textAlign: "center", color: "#64748b" }}>
            No openings available at the moment.
          </p>
        )}

        {Array.isArray(jobs) && jobs.map((job) => (
          <div className="job-row" key={job.id}>

            <div className="job-left">
              <h3>{job.job_title}</h3>
              <div className="job-tags">
                <span>{job.experience}</span>
                <span>Posted: {job.date_posted}</span>
                <span>Last Date: {job.last_date}</span>
              </div>
            </div>

            <div className="job-right">
              <div
                className={`job-description ${expandedJob === job.id ? "expanded" : "collapsed"
                  }`}
              >
                <p>{job.description}</p>
              </div>

              <div className="job-actions">
                <button
                  className="read-btn"
                  onClick={() => toggleReadMore(job.id)}
                >
                  {expandedJob === job.id ? "Read Less" : "Read More"}
                </button>

                <button
                  className="apply-btn"
                  onClick={() => setSelectedJob(job)}
                >
                  Apply Now
                </button>
              </div>
            </div>

          </div>
        ))}
        <div><h2>Apply Now : hr@ignosi.co.in</h2></div>
      </section>

      {/* APPLICATION MODAL */}
      {selectedJob && (
        <div className="modal-overlay">
          <div className="modal">
            <h2>Apply for {selectedJob.job_title}</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="full_name"
                placeholder="Full Name"
                required
                onChange={handleChange}
                value={formData.full_name}
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                required
                onChange={handleChange}
                value={formData.email}
              />

              <input
                type="text"
                name="phone"
                placeholder="Phone"
                required
                onChange={handleChange}
                value={formData.phone}
              />

              <input
                type="file"
                name="resume"
                required
                onChange={handleChange}
              />

              <textarea
                name="cover_letter"
                placeholder="Cover Letter"
                onChange={handleChange}
                value={formData.cover_letter}
              ></textarea>

              <div
                id="recaptcha-careers"
                style={{ marginBottom: "15px" }}
              ></div>

              <div className="modal-buttons">
                <button type="submit" className="submit-btn">
                  Submit
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setSelectedJob(null)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}

export default Careers;